(function($) {
  const carousel = document.querySelector('.dtyb-carousel');

  if (!carousel) {
    return;
  }

  const classes = {
    slide: '.dtyb-slide',
    active: '.dtyb-slide.active',
    header: '.dtyb-slide__header',
    images: '.dtyb-slide__images .image-slider',
    details: 'details-slide',
    tab: 'tab-slide',
  };

  const slides = carousel.querySelectorAll(classes.slide);
  const prevArrow = carousel.querySelector('.arrow.arrow--prev');
  const nextArrow = carousel.querySelector('.arrow.arrow--next');
  const slideCount = carousel.dataset.slideCount;

  /**
   * Standard debounce function
   * @param {function} fn - The function to call
   * @param {function} time - How long to wait
   */
  const debounce = (fn, time) => {
    let timeout;

    return function() {
      const functionCall = () => fn.apply(this, arguments);

      clearTimeout(timeout);
      timeout = setTimeout(functionCall, time);
    };
  };

  const setSlide = e => {
    const slideIndex = e.currentTarget.dataset.slide;
    const newSlides = document.querySelectorAll(`${classes.slide}[data-slide="${slideIndex}"]`);
    const activeSlides = document.querySelectorAll(classes.active);

    if (!activeSlides || !newSlides) {
      return;
    }

    activeSlides.forEach(activeSlide => {
      activeSlide.classList.remove('active');
    });

    newSlides.forEach(newSlide => {
      newSlide.classList.add('active');
    });
  };

  const navigateSlide = direction => {
    let slideIndex = 1;
    const activeSlides = document.querySelectorAll(classes.active);

    if (!activeSlides) {
      return;
    }

    activeSlides.forEach(activeSlide => {
      activeSlide.classList.remove('active');
      slideIndex = activeSlide.dataset.slide;
    });

    let newIndex = parseInt(slideIndex) + 1;

    if (direction !== 'prev' && newIndex > slideCount) {
      newIndex = 1;
    }

    if (direction === 'prev') {
      newIndex = parseInt(slideIndex) - 1;

      if (newIndex < 1) {
        newIndex = slideCount;
      }
    }

    const newSlides = document.querySelectorAll(`${classes.slide}[data-slide="${newIndex}"]`);

    newSlides.forEach(newSlide => {
      newSlide.classList.add('active');
    });
  };

  /**
   * Set arrow position
   */
  const arrowPos = () => {
    const imageBlock = carousel.querySelector(classes.images);
    const headerBlock = carousel.querySelector(classes.header);
    const topHeight = imageBlock.offsetHeight + headerBlock.offsetHeight;
    const arrowTop = Math.floor(topHeight / 2);
    prevArrow.style.top = `${arrowTop}px`;
    nextArrow.style.top = `${arrowTop}px`;
  };

  const imageSlider = currentSlide => {
    const images = currentSlide.querySelector(classes.images);

    if (!images) {
      return;
    }

    $(images)
      .on('init', () => {
        arrowPos();
      })
      .slick({
        arrows: false,
        dots: true,
        draggable: true,
      });

    window.addEventListener(
      'resize',
      debounce(() => {
        arrowPos();
      }, 300)
    );
  };

  slides.forEach(slide => {
    imageSlider(slide);

    if (!slide.classList.contains(classes.details) && !slide.classList.contains(classes.tab)) {
      return;
    }

    slide.addEventListener('click', setSlide);
  });

  prevArrow.addEventListener('click', () => {
    navigateSlide('prev');
  });
  nextArrow.addEventListener('click', () => {
    navigateSlide('next');
  });
})(jQuery); // jQuery for slick
